var _effectorFileName = "/src/apps/providers/with-providers.ts";
import { compose } from '@effable/misc';
import { withBalancer } from './with-balancer';
import { withEffector } from './with-effector';
import { withFresnel } from './with-fresnel';
import { withTheme } from './with-theme';
export const withProviders = compose(withEffector, withTheme, withFresnel, withBalancer);